// extracted by mini-css-extract-plugin
module.exports = {"ViewMore":"LoadMore_ViewMore__2enLU","ViewMoreText":"LoadMore_ViewMoreText__1bRvW"};